import { FC, useCallback, useEffect, useRef } from 'react';
import { ClickPosition } from '~/utils/click-position';
import { useViewTracking } from '~/utils/use-view-tracking';
import BreadcrumbsItem from './breadcrumbs-item';

import './style.scss';

interface IProps {
  list: string[];
}

const BreadcrumbsNavigation: FC<IProps> = ({ list }) => {
  const ref = useRef<HTMLOListElement>(null);

  const scrollSmoothTo = function (el: HTMLElement, position: number, duration: number) {
    // 当前滚动高度
    const scrollLeft = el.scrollLeft;
    // 滚动step方法

    const cosParameter = (scrollLeft - position) / 2;
    let scrollCount = 0;
    let oldTimestamp = performance.now();
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    function step(newTimestamp: number) {
      scrollCount += Math.PI / (duration / (newTimestamp - oldTimestamp));

      // 贝塞尔曲线尾巴，直接跳转到目标位置
      if (scrollCount >= Math.PI) {
        el.scrollTo(position, 0);
        return;
      }

      el.scrollTo(Math.round(position + cosParameter + cosParameter * Math.cos(scrollCount)), 0);
      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  };
  const content = list.map((query, index) => {
    if (index === list.length - 1) {
      return <BreadcrumbsItem isLast={true} query={query} index={index} />;
    }

    return <BreadcrumbsItem isLast={false} query={query} index={index} />;
  });

  const breadcrumbsObservedRef = useViewTracking<HTMLAnchorElement>({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_position: ClickPosition.kep_breadcrumbs,
      });
    }, []),
  });

  useEffect(() => {
    // 默认滚动到最右侧
    if (ref.current) {
      const element = ref.current;
      const scrollDistance = element.scrollWidth - element.clientWidth;
      scrollSmoothTo(element, scrollDistance, 50);
    }
  }, [ref, list]);

  return (
    <nav ref={breadcrumbsObservedRef} className="nav-container">
      <ol key="kep-breadcrumbs-navigation-ol" className="nav-content" ref={ref}>
        {content}
      </ol>
    </nav>
  );
};

export default BreadcrumbsNavigation;
